import { IKeytipProps } from "@fluentui/react/lib/Keytip";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { getDefaultKeytipProps } from "@1js/acui-keytip";

const ribbonOffset = 32; // Ribbon item keytips should be positioned 32px from the top

export const deriveButtonKeytip = memoizeFunction(
  (
    keytipProps?: IKeytipProps,
    onExecute?: (executeTarget: HTMLElement, target: HTMLElement) => void
  ): IKeytipProps | undefined => {
    return keytipProps
      ? getDefaultKeytipProps(keytipProps, ribbonOffset, onExecute)
      : undefined;
  }
);
